import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

/** The names of these categories, in the shop's own order. An id that no
 *  longer exists drops out rather than showing as a raw uuid. */
export function useCategoryNames(ids: string[] | undefined): string[] {
  const categoriesQuery = useQuery({
    queryKey: ['categories'],
    queryFn: () => api.categories.list(),
    staleTime: 60_000,
    enabled: (ids?.length ?? 0) > 0,
  });
  if (!ids?.length) return [];
  const wanted = new Set(ids);
  return (categoriesQuery.data?.items ?? [])
    .filter((c) => wanted.has(c.id))
    .map((c) => c.display_name || c.name);
}
